import eventsTest from './events'

export default eventsTest
